import { ReactNode, createContext, useContext, useMemo, useRef } from 'react';
import { Socket, io } from 'socket.io-client';

const SOCKET_HOST = process.env.REACT_APP_SOCKET_HOST as string;

type DarknetSocket = Socket<DarknetSocketEvents.ListenEvents, DarknetSocketEvents.EmitEvents>;

interface DarknetSocketState {
    socket: DarknetSocket
}

export const SocketContext = createContext<DarknetSocketState>({
    socket: io()
});

export const SocketProvider = (props: { children?: ReactNode }) => {
    const socketRef = useRef<DarknetSocket>();

    const darknetSocketState = useMemo(() => {
        if (!socketRef.current) {
            socketRef.current = io(SOCKET_HOST, { transports: ['websocket'] });
        }

        return {
            socket: socketRef.current
        };
    }, []);

    return (
        <SocketContext.Provider value={darknetSocketState}>
            {props.children}
        </SocketContext.Provider>
    )
}

export const useDarknetSocket = () => useContext(SocketContext);